const toURLParams = (json) => json && Object.keys(json).map(key => (
  (typeof json[key] !== 'undefined') ? encodeURIComponent(key) + '=' + encodeURIComponent(json[key]) : null
)).filter(value => value !== null).join('&');

export default toURLParams;



// WEBPACK FOOTER //
// ./src/utils/toURLParams.js